export function downloadDocument(url, filename) {
    const link = document.createElement("a");
    link.download = filename || true;
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
